
const state = {
  agency_id: undefined,
  builder_version: undefined,
  campaign_id: undefined,
  disable_custom_items: false,
  disable_price_override: false,
  disable_section_editing: false,
  hidden: false,
  id: null,
  title: '',
  total: 0,
  user_ids: [],
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'title' },
]

export default state
